import request from '@/util/request';

export const getFeeReturnDetailList = (returnId) => {
  return request({
    url: '/api/feeBack/feereturn/detailList',
    method: 'get',
    params: {
      returnId,
    },
  });
};

export const getFeeReturnListPage = (current, size, params) => {
  return request({
    url: '/api/feeBack/feereturnlist/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getFeeReturnListDetail = (id) => {
  return request({
    url: '/api/feeBack/feereturnlist/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const removeFeeReturnList = (ids) => {
  return request({
    url: '/api/feeBack/feereturnlist/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const addFeeReturnList = (row) => {
  return request({
    url: '/api/feeBack/feereturnlist/submit',
    method: 'post',
    data: row,
  });
};

export const updateFeeReturnList = (row) => {
  return request({
    url: '/api/feeBack/feereturnlist/submit',
    method: 'post',
    data: row,
  });
};
